<template>
  <div class="character-list order userlist">
    <head-panel title="账户管理" subtitle="ACCOUNT MANAGEMENT" :exportExc="false"></head-panel>
    <div class="oprPanel">
      <h3 class="subLabel">账户管理</h3>
      <div class="selectBox">
        <label class="sel_lab fl">账户类型</label>
        <ny-select
          :data="subAccount.roleTypeMenu"
          v-model="subAccount.curRoleType"
          :keyValue="['value', 'name']"
          @changeSelectMenu="changeSelect"
          part="adr"
          placeholder="请选择"
          class="advertiseSelect input_sm mr25"
        ></ny-select>
        <label class="sel_lab fl">账户名称</label>
        <el-input class="searchBox" icon="search" v-model="adverName"></el-input>
        <el-button class="oprSuccess mr55" @click="searchData">搜索</el-button>
        <el-button class="oprSuccess fr add_order add_adr" @click="addUser">
          <b>+&nbsp;</b>
          <i>新增账户</i>
        </el-button>
      </div>
      <div class="panel-content__table-wrap">
        <ny-table
          class="panel-content__table"
          :page="subAccount.page"
          @size-change="changePageSize"
          @current-change="changePageSize"
          :slot-columns="['verify', 'mi_verify', 'ireader_verify']"
          @cell-click="handleCellClick"
        >
          <template slot="verify" slot-scope="{ row, column }">
            <span :class="{ 'is-refuse': row.verify === '已拒绝'  }">{{row[column.property]}}</span>
          </template>
          <template slot="mi_verify" slot-scope="{ row, column }">
            <span :class="{ 'is-refuse': row.mi_verify === '已拒绝'  }">{{row[column.property]}}</span>
          </template>
          <template slot="ireader_verify" slot-scope="{ row, column }">
            <span :class="{ 'is-refuse': row.ireader_verify === '已拒绝'  }">{{row[column.property]}}</span>
          </template>
          <el-table-column label="操作" width="220" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.roles"
                size="small"
                class="is-edit"
                @click="edit(scope.row.id,scope.row.user_type, scope.row)"
              >编辑</el-button>
              <el-button size="small" v-if="false" @click="review(scope.row)">审核</el-button>
              <el-button
                size="small"
                v-if="scope.row.roles && platform ==='admin'"
                class="is-remove"
                @click="remove(scope.row.id)"
              >删除</el-button>
              <el-button
                size="small"
                class="is-view"
                @click="show(scope.row.id,scope.row.id_tag, scope.row)"
              >查看</el-button>
            </template>
          </el-table-column>
        </ny-table>
      </div>
    </div>
    <ny-dialog v-model="refuse" size="tiny" title="审核被拒原因：">
      <p class="panel-content__refuse" v-for="(item, index) in refuseReason" :key="index">{{ item }}</p>
      <el-button slot="footer" @click="refuse = false">确定</el-button>
    </ny-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { headPanel, NyTable, NySelect, NyDialog } from '@/global/components';
export default {
  name: 'user-list',
  data () {
    return {
      adverName: '',
      loading: false,
      platform: '',
      addPrice: {
        title: '加款金额',
        type: 'add'
      },
      setMax: '',
      refund: {
        title: '退款金额',
        type: 'refund'
      },
      refuse: false,
      refuseReason: [],
      errorShow: {
        add: false,
        refund: false
      },
      premiumDialog: {// 加款
        visible: false,
        isClickModal: false
      },
      refundDialog: {// 退款
        visible: false,
        isClickModal: false
      },
      committing: false // 提交状态
    }
  },
  computed: {
    ...mapGetters({
      subAccount: 'subAccount/subAccount',
      userid: 'login/userid'
    })
  },
  created () {
    this.platform = this.$router.currentRoute.meta.platform;
    this.init()
  },
  methods: {
    ...mapActions(['userList', 'deleteUser']),
    async init () {
      await this.$store.dispatch('subAccount/getRoleTypeMenu', { params: { plat: this.platform }, isAll: true })
      this.getUserList()
    },
    getUserList ({ pageSize = this.subAccount.page.pageSize, currentPage = this.subAccount.page.currentPage } = {}) { // 获取用户列表
      this.loading = true;
      this.$store.dispatch('subAccount/userList', {
        data: {
          page: currentPage,
          perpage: pageSize,
          role_type: this.subAccount.curRoleType,
          user_name: this.adverName,
          plat: this.platform
        }
      })
    },
    handleCellClick ({ row, column, event, index }) {
      // if (column.property !== 'verify' || row.verify === '已审核') return
      let clickCell = ['verify', 'mi_verify', 'ireader_verify']
      let reson = {
        verify: 'reason',
        mi_verify: 'mi_reason',
        ireader_verify: 'ireader_reason'
      }
      if (clickCell.indexOf(column.property) > -1) {
        if (row[column.property] === '已拒绝') {
          this.refuse = true
          this.refuseReason = row[reson[column.property]].msg ? row[reson[column.property]].msg.split(/[\n↵]/g) : ''
        }
      }
    },
    changePageSize ({ currentPage, pageSize }) { // 当表格显示条数发生变化是触发的函数
      this.getUserList({ currentPage, pageSize });
    },
    // 编辑用户
    edit (id, tag, row) {
      this.$router.push({ name: 'oprAgencyUser', params: { id: id, userType: tag, type: 'edit', donewsStatus: row.audit_status } })
    },
    show (id, tag, row) {
      this.$router.push({ name: 'oprAgencyUser', params: { id: id, userType: tag, type: 'show', donewsStatus: row.audit_status } })
    },
    // 删除用户
    remove (id) {
      this.$confirm('“确认永久删除此用户？”', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('subAccount/deleteUser', { data: { id: id } }).then((data) => {
          if (data.code === 1) {
            this.getUserList();
            this.$message({
              type: 'success',
              message: '已删除!'
            });
          }
        });
      }).catch(() => { })
    },
    review (row) {
      if (!row.has_qualif) {
        this.$message('请完善资质')
        return false
      }
      this.$router.push({ name: 'oprAgencyUser', params: { id: row.id, type: 'review' } })
    },
    addUser () {
      this.$router.push('/oprUser/0')
    },
    searchData () {
      this.subAccount.page.resetData()
      this.getUserList()
    },
    changeSelect (val) {
    }
  },
  components: {
    headPanel,
    NyTable,
    NySelect,
    NyDialog
  }
};
</script>

<style lang="scss" type="text/scss">
.userlist {
  .selectBox {
    .mr25 {
      margin-right: 25px;
    }
  }
}
</style>
